import React from 'react';

import CalendarTodayRoundedIcon from '@mui/icons-material/CalendarTodayRounded';
import ChecklistRoundedIcon from '@mui/icons-material/ChecklistRounded';
import CurrencyExchangeRoundedIcon from '@mui/icons-material/CurrencyExchangeRounded';
import EditRoundedIcon from '@mui/icons-material/EditRounded';
import EventAvailableRoundedIcon from '@mui/icons-material/EventAvailableRounded';
import HubRoundedIcon from '@mui/icons-material/HubRounded';
import LoyaltyRoundedIcon from '@mui/icons-material/LoyaltyRounded';
import MenuBookRoundedIcon from '@mui/icons-material/MenuBookRounded';
import MessageRoundedIcon from '@mui/icons-material/MessageRounded';
import MonetizationOnRoundedIcon from '@mui/icons-material/MonetizationOnRounded';
import PunchClockRoundedIcon from '@mui/icons-material/PunchClockRounded';
import StorefrontRoundedIcon from '@mui/icons-material/StorefrontRounded';
import TagRoundedIcon from '@mui/icons-material/TagRounded';
import VideoCameraFrontRoundedIcon from '@mui/icons-material/VideoCameraFrontRounded';

import { LinkOption } from './types';

export const UPCOMING_BIRTHDAY_THRESHOLD_IN_DAYS = 7;

export const STAFF_TOOLS: LinkOption[] = [
  {
    label: 'Slack',
    description: 'Internal & external communication',
    href: 'https://cognitotuition.slack.com',
    icon: <MessageRoundedIcon />,
  },
  {
    label: 'Notion',
    description: 'Knowledge & information hub',
    href: 'https://www.notion.so',
    icon: <HubRoundedIcon />,
  },
  {
    label: 'When I Work',
    description: 'Staff roster & timesheet',
    href: 'https://appx.wheniwork.com/',
    icon: <PunchClockRoundedIcon />,
  },
  {
    label: 'Xero Me',
    description: 'Leave requests & payslips',
    href: 'https://payroll.xero.com/EmployeePortal',
    icon: <MonetizationOnRoundedIcon />,
  },
  {
    label: 'Zoom',
    description: 'admin@cognitotuition.com / Wiad8870',
    href: 'https://us02web.zoom.us/j/4494961628',
    icon: <VideoCameraFrontRoundedIcon />,
  },
];

export const STUDENT_TOOLS: LinkOption[] = [
  {
    label: 'Slack',
    description: 'Contact admin & ask subject questions 24/7',
    href: 'https://cognitotuition.slack.com',
    icon: <MessageRoundedIcon />,
  },
  {
    label: 'Zoom',
    description: 'All online classes & webinars',
    href: 'https://us02web.zoom.us/j/4494961628',
    icon: <VideoCameraFrontRoundedIcon />,
  },
];

export const ADMIN_LINKS: LinkOption[] = [
  {
    label: 'Class of 2025 Schedule',
    description: 'Course schedule for the Class of 2025',
    href: 'http://schedule25.cognitotuition.com',
    icon: <CalendarTodayRoundedIcon />,
  },
  {
    label: 'Class of 2026 Schedule',
    description: 'Course schedule for the Class of 2026',
    href: 'http://schedule26.cognitotuition.com',
    icon: <CalendarTodayRoundedIcon />,
  },
  {
    label: 'Admin Handbook',
    description: 'Guides, rules, and policies for admins',
    href: 'http://adminhandbook.cognitotuition.com/',
    icon: <MenuBookRoundedIcon />,
  },
  {
    label: 'Staff Benefits',
    description: 'Your perks as a Cognito team member!',
    href: 'https://drive.google.com/file/d/1ZAldBOygsGmgWnWXoy8V5Pwym--Ml_nq/view?usp=sharing',
    icon: <LoyaltyRoundedIcon />,
  },
  {
    label: 'Tutor Availability Matrix',
    description: 'Matrix of tutor availability',
    href: 'http://tutormatrix.cognitotuition.com/',
    icon: <EventAvailableRoundedIcon />,
  },
  {
    label: 'Instagram (@cognito.tuition)',
    description: 'Follow us for the latest news!',
    href: 'https://www.instagram.com/cognito.tuition/',
    icon: <TagRoundedIcon />,
  },
  {
    label: 'Merch Store',
    description: 'Get your hands on the latest hoodies & merch here!',
    href: 'http://store.cognitotuition.com',
    icon: <StorefrontRoundedIcon />,
  },
  {
    label: 'Reimbursements Form',
    description: 'Submit your reimbursement requests here!',
    href: 'https://docs.google.com/forms/d/e/1FAIpQLSeHLiHnGgUkad29jMUkhTjiehl0uGq0Bq-mZSo-4kMgYQeEiw/viewform',
    icon: <CurrencyExchangeRoundedIcon />,
  },
];

export const TEACHER_LINKS: LinkOption[] = [
  {
    label: 'Class of 2025 Schedule',
    description: 'Course schedule for the Class of 2025',
    href: 'http://schedule25.cognitotuition.com',
    icon: <CalendarTodayRoundedIcon />,
  },
  {
    label: 'Class of 2026 Schedule',
    description: 'Course schedule for the Class of 2026',
    href: 'http://schedule26.cognitotuition.com',
    icon: <CalendarTodayRoundedIcon />,
  },
  {
    label: 'Chemistry Tips',
    description: 'Tips database for chemistry cources',
    href: 'https://humble-airbus-6b2.notion.site/199a66d817df80f3b4d0f13a1c99cf39?v=199a66d817df807c8a6f000c731008ea&pvs=4',
    icon: <ChecklistRoundedIcon />,
  },
  {
    label: 'Physics Tips',
    description: 'Tips database for physics cources',
    href: 'https://humble-airbus-6b2.notion.site/199a66d817df8032b444e53718cfd4a2?v=199a66d817df80949e24000ccc2d4823&pvs=4',
    icon: <ChecklistRoundedIcon />,
  },
  {
    label: 'Mathematics Tips',
    description: 'Tips database for maths cources',
    href: 'https://humble-airbus-6b2.notion.site/199a66d817df80ce9681d5eff204d82a?v=199a66d817df818ea325000c1f0dfda6&pvs=4',
    icon: <ChecklistRoundedIcon />,
  },
  {
    label: 'Tutor Handbook',
    description: 'Guides, rules, and policies for tutors',
    href: 'http://tutorhandbook.cognitotuition.com/',
    icon: <MenuBookRoundedIcon />,
  },
  {
    label: 'Staff Benefits',
    description: 'Your perks as a Cognito team member!',
    href: 'https://drive.google.com/file/d/1ZAldBOygsGmgWnWXoy8V5Pwym--Ml_nq/view?usp=sharing',
    icon: <LoyaltyRoundedIcon />,
  },
  {
    label: 'Tutor Availability Matrix',
    description: 'Matrix of tutor availability',
    href: 'http://tutormatrix.cognitotuition.com/',
    icon: <EventAvailableRoundedIcon />,
  },
  {
    label: 'Exam Marking Guide',
    description: 'Processes and standards for exam marking',
    href: 'https://docs.google.com/presentation/d/1MWxRqIxcV7Bw0QtiBAia2oc_14XqbHl_pbeN1_uorEM/edit?usp=sharing',
    icon: <EditRoundedIcon />,
  },
  {
    label: 'Instagram (@cognito.tuition)',
    description: 'Follow us for the latest news!',
    href: 'https://www.instagram.com/cognito.tuition/',
    icon: <TagRoundedIcon />,
  },
  {
    label: 'Merch Store',
    description: 'Get your hands on the latest hoodies & merch here!',
    href: 'http://store.cognitotuition.com',
    icon: <StorefrontRoundedIcon />,
  },
  {
    label: 'Reimbursements Form',
    description: 'Submit your reimbursement requests here!',
    href: 'https://docs.google.com/forms/d/e/1FAIpQLSeHLiHnGgUkad29jMUkhTjiehl0uGq0Bq-mZSo-4kMgYQeEiw/viewform',
    icon: <CurrencyExchangeRoundedIcon />,
  },
];

export const STUDENT_LINKS: LinkOption[] = [
  {
    label: 'Class of 2025 Schedule',
    description: 'Course schedule for the Class of 2025',
    href: 'http://schedule25.cognitotuition.com',
    icon: <CalendarTodayRoundedIcon />,
  },
  {
    label: 'Class of 2026 Schedule',
    description: 'Course schedule for the Class of 2026',
    href: 'http://schedule26.cognitotuition.com',
    icon: <CalendarTodayRoundedIcon />,
  },
  {
    label: 'Instagram (@cognito.tuition)',
    description: 'Follow us for the latest news!',
    href: 'https://www.instagram.com/cognito.tuition/',
    icon: <TagRoundedIcon />,
  },
  {
    label: 'Merch Store',
    description: 'Get your hands on the latest hoodies & merch here!',
    href: 'http://store.cognitotuition.com',
    icon: <StorefrontRoundedIcon />,
  },
];
